function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GalleryLarge = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2C3.11929 2 2 3.11929 2 4.5V8.5C2 9.88071 3.11929 11 4.5 11H8.5C9.88071 11 11 9.88071 11 8.5V4.5C11 3.11929 9.88071 2 8.5 2H4.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H8.5C8.77614 4 9 4.22386 9 4.5V8.5C9 8.77614 8.77614 9 8.5 9H4.5C4.22386 9 4 8.77614 4 8.5V4.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 13C3.11929 13 2 14.1193 2 15.5V19.5C2 20.8807 3.11929 22 4.5 22H8.5C9.88071 22 11 20.8807 11 19.5V15.5C11 14.1193 9.88071 13 8.5 13H4.5ZM4 15.5C4 15.2239 4.22386 15 4.5 15H8.5C8.77614 15 9 15.2239 9 15.5V19.5C9 19.7761 8.77614 20 8.5 20H4.5C4.22386 20 4 19.7761 4 19.5V15.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.5C13 3.11929 14.1193 2 15.5 2H19.5C20.8807 2 22 3.11929 22 4.5V8.5C22 9.88071 20.8807 11 19.5 11H15.5C14.1193 11 13 9.88071 13 8.5V4.5ZM15.5 4C15.2239 4 15 4.22386 15 4.5V8.5C15 8.77614 15.2239 9 15.5 9H19.5C19.7761 9 20 8.77614 20 8.5V4.5C20 4.22386 19.7761 4 19.5 4H15.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 13C14.1193 13 13 14.1193 13 15.5V19.5C13 20.8807 14.1193 22 15.5 22H19.5C20.8807 22 22 20.8807 22 19.5V15.5C22 14.1193 20.8807 13 19.5 13H15.5ZM15 15.5C15 15.2239 15.2239 15 15.5 15H19.5C19.7761 15 20 15.2239 20 15.5V19.5C20 19.7761 19.7761 20 19.5 20H15.5C15.2239 20 15 19.7761 15 19.5V15.5Z",
    fill: "currentColor"
  })]
}));
//# sourceMappingURL=GalleryLarge.js.map